import React from "react"
import { Link } from "gatsby"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import StoryCardVideo from "./story-card-video"
import { CardWrapper } from "./story.styled"

const StoryCard = ({ data, index, isSingleStory, reverse = false }) => {
  const {
    videoPoster,
    video,
    name,
    quote,
    product,
    duration,
    linkToPdp,
    linkTo,
  } = data

  const handleCTAClick = () => {
    const eventObj = {
      destination: linkTo,
      module_location: "bottom_fold",
      module_name: "Meet " + name,
      text: `Taking ${product} for ${duration}`,
      type: "link",
    }
    segmentEvent("Marketing CTA Clicked", eventObj)
  }

  const paddings = [0, 0, 0, 24, 40]

  return (
    <CardWrapper
      className={`${
        index !== 0 && "mt-[32px] sm:mt-[80px] md:mt-[164px] lg:mt-[240px]"
      }`}
      pr={index % 2 === 0 ? paddings : 0}
      pl={index % 2 === 0 ? 0 : paddings}
    >
      <Flex flexWrap="wrap">
        <StoryCardVideo
          video={video}
          videoPoster={videoPoster}
          name={name}
          reverse={reverse}
          isSingleStory={isSingleStory}
        />
        <Box
          className={`info-box ${isSingleStory ? "single-story" : ""}`}
          pt={isSingleStory ? [24, null, 24, 0] : [24, null, 24, 40]}
          order={[2, 2, 2, 2, !reverse ? 2 : 1]}
          px={isSingleStory ? [0, null, null, 32] : 0}
          width={isSingleStory ? [1, null, null, 0.5] : 1}
        >
          {isSingleStory ? (
            <TextElementNova
              element="p"
              text={`“${quote}”`}
              className="quote-text mb-[16px]"
              classes={{
                default: "Body-30-Dia-Normal",
                1024: "Body-20-Dia-Normal",
                1180: "Body-30-Dia-Normal",
              }}
            />
          ) : (
            <TextElementNova
              element="p"
              text={`“${quote}”`}
              className="Body-30-Dia-Normal quote-text mb-[16px]"
            />
          )}

          <TextElementNova
            element="p"
            text={name}
            className="Caption-10-Dia-Uppercase mb-[40px]"
          />
          <div className="bottom-wrap">
            {linkToPdp ? (
              <div className="product-link">
                <Link
                  to={linkTo}
                  className="inline link-text mr-1 text-nova-transparency-black-70"
                >
                  <TextElementNova
                    element="span"
                    text="Taking"
                    className="inline Body-10-Dia-Normal mr-1 text-nova-transparency-black-70"
                  />
                  <button
                    type="submit"
                    onClick={handleCTAClick}
                    onKeyPress={handleCTAClick}
                    className="text-nova-brand-primary-80 taking-button"
                  >
                    {product}
                  </button>
                </Link>
                <TextElementNova
                  element="p"
                  text={`for ${duration}.`}
                  className="inline Body-10-Dia-Normal text-nova-transparency-black-70"
                />
              </div>
            ) : (
              <div className="product-text">
                <TextElementNova
                  element="span"
                  text="Taking"
                  className="inline Body-10-Dia-Normal mr-1 text-nova-transparency-black-70"
                />
                <TextElementNova
                  element="span"
                  text={product}
                  className="inline Body-10-Dia-Normal mr-1 text-nova-brand-primary-80"
                />
                <TextElementNova
                  element="span"
                  text={`for ${duration}.`}
                  className="inline Body-10-Dia-Normal text-nova-transparency-black-70"
                />
              </div>
            )}
            <Box
              height={"1px"}
              width={1}
              className="bg-nova-transparency-black-20"
              my={16}
            ></Box>
            <TextElementNova
              element="p"
              text={`Real customer compensated for sharing their story.`}
              className="Caption-10-Dia-Normal text-nova-transparency-black-70"
            />
          </div>
        </Box>
      </Flex>
    </CardWrapper>
  )
}

export default StoryCard
